import { gql } from "@apollo/client";

export const ANALYTICS_EMBED_FOR_SUBACCOUNT = gql`
  query analyticsEmbedForSubaccount(
    $subaccountId: String!
    $timeframe: String!
    $dashboardPath: String!
  ) {
    analyticsEmbedForSubaccount(
      input: {
        subaccountId: $subaccountId
        timeframe: $timeframe
        dashboardPath: $dashboardPath
      }
    ) {
      signedEmbedUrl
      expiresAt
    }
  }
`;

export const ANALYTICS_EMBED_FOR_TENANT = gql`
  query analyticsEmbedForTenant($timeframe: String!, $dashboardPath: String!) {
    analyticsEmbedForTenant(
      input: { timeframe: $timeframe, dashboardPath: $dashboardPath }
    ) {
      signedEmbedUrl
      expiresAt
    }
  }
`;
